import { render, staticRenderFns } from "./BiometricCard.vue?vue&type=template&id=2f86e592&scoped=true"
import script from "./BiometricCard.vue?vue&type=script&lang=js"
export * from "./BiometricCard.vue?vue&type=script&lang=js"
import style0 from "./BiometricCard.vue?vue&type=style&index=0&id=2f86e592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f86e592",
  null
  
)

export default component.exports